<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <div class="warp mt20">
            <div class="warp-body">
                <div class="clearfix">
                    <h2 class="fl">选择适合您的VIP套餐</h2>
                    <p class="ml20 mt5 fl"><i class="icons rank-icon4"></i>　<strong>定制VIP</strong> 如需定制VIP套餐内容，请拨打客服电话 <strong>400-6565-919</strong></p>
                </div>
                <div class="vip-list clearfix mt30" v-if="list != ''">
                    <div class="item">
                        <div class="vips">
                            <span class="title">权限对比</span>
                            <span class="prize"></span>
                            <span class="val">分析词/方案数量</span>
                            <span class="val">筛选时间</span>
                            <span class="val">单次最大导出数据量</span>
                            <span class="val">预警方式</span>
                            <span class="val">人工预警设置</span>
                            <!-- <span class="val">全文搜索</span> -->
                            <span class="val">免费简报数量</span>
                            <span class="val">对比方案</span>
                            <span class="val">免费短信数量</span>
                            <span class="val">热点事件库</span>
                            <span class="val">接收人设置</span>
                            <span class="val">报告下载</span>
                            <span class="val">免费下载数据量</span>
                        </div>
                    </div>
                    <div class="item"  >
                        <div class="vips vip-move">
                            <span class="title"><i class="icons rank-icon1"></i>{{vipName[i]}}</span>
                            <span class="prize">
                                <i class="num">{{list[0].qingBeiNum}}</i>清贝/月　　<button class="btn btn-jbcoffee" type="button" @click="vipBuy(list[0].memberType);" v-if="isCanBuy[0] === 1">立即购买</button>
                            </span>
                            <!-- <span v-if="index < 12" v-for="(item,index) in list[0].authorityExplain" :key="index" class="val" v-html="item.value" /> -->
                            <span class="val"><strong>10</strong>个分析词/<strong>5</strong>个方案</span>
                            <span class="val">近<strong>90</strong>天</span>
                            <span class="val"><strong>1000</strong>条</span>
                            <span class="val"><strong>邮件</strong>+<strong>微信</strong>+<strong>短信</strong></span>
                            <!-- <span class="val"><i class="icons right-icon"></i></span> -->
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>无限制</strong></span>
                            <span class="val"><strong>20</strong>个</span>
                            <span class="val"><strong>1000</strong>条/月</span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>邮件无限</strong>+<strong>微信无限</strong>+<strong>短信2个</strong></span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>3000</strong>条/月</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="vips vip-move">
                            <span class="title"><i class="icons rank-icon3"></i>黄金会员</span>
                            <span class="prize">
                                <i class="num">{{list[1].qingBeiNum}}</i>清贝/月　　<button class="btn btn-jborange" type="button" @click="vipBuy(list[1].memberType);" v-if="isCanBuy[1] === 1">立即购买</button>
                            </span>
                            <span class="val"><strong>15</strong>个分析词/<strong>10</strong>个方案</span>
                            <span class="val">近<strong>90</strong>天</span>
                            <span class="val"><strong>2000</strong>条</span>
                            <span class="val"><strong>邮件</strong>+<strong>微信</strong>+<strong>短信</strong></span>
                            <!-- <span class="val"><i class="icons right-icon"></i></span> -->
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>无限制</strong></span>
                            <span class="val"><strong>50</strong>个</span>
                            <span class="val"><strong>3000</strong>条/月</span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>邮件无限</strong>+<strong>微信无限</strong>+<strong>短信4个</strong></span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>6000</strong>条/月</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="vips vip-move">
                            <span class="title"><i class="icons rank-icon5"></i>钻石会员</span>
                            <span class="prize">
                                <i class="num">{{list[2].qingBeiNum}}</i>清贝/月　　<button class="btn btn-jbblue" type="button" @click="vipBuy(list[2].memberType);" v-if="isCanBuy[2] === 1">立即购买</button>
                            </span>
                            <span class="val"><strong>20</strong>个分析词/<strong>15</strong>个方案</span>
                            <span class="val">近<strong>90</strong>天</span>
                            <span class="val"><strong>5000</strong>条</span>
                            <span class="val"><strong>邮件</strong>+<strong>微信</strong>+<strong>短信</strong></span>
                            <!-- <span class="val"><i class="icons right-icon"></i></span> -->
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>无限制</strong></span>
                            <span class="val"><strong>100</strong>个</span>
                            <span class="val"><strong>无限制</strong></span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>邮件无限</strong>+<strong>微信无限</strong>+<strong>短信4个</strong></span>
                            <span class="val"><i class="icons right-icon"></i></span>
                            <span class="val"><strong>10000</strong>条/月</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import vipMenu from './vipMenu.vue';
export default {
    components:{vipMenu},
    data() {
        return {
           list:[],//会员列表
           isCanBuy:[],//判断是否可以购买
           currentVip:1,//当前会员等级
           vipName :['普通会员','黄金会员','钻石会员','基础版会员','标准版会员','专业版会员']
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getvipList();
        })
    },
    created() {
		
    },
    methods: {
        // 获取购买信息
        getvipList () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/member-meals',null,r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.list = r.data.list;
                    for(let i of r.data.list){
                        that.isCanBuy.push(i.isCanBuy);
                    }
                    that.currentVip = r.data.memberType;
                })
            })
        },
        // 会员购买
        vipBuy (type) {
            let form = '';
            if(type === this.currentVip){//续费
                form = 'renew';
            }else{//购买
                form = 'buy';
            }
            this.$router.push({ path:''+this.$parent.baseUrl+'/renew',query:{memberType:type,form:form}})
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipBuy.vue